/* eslint-disable default-case */
import Enums from "./Enums";
import LoginService from "../services/LoginService";
import jwtDecode from 'jwt-decode';
// import * as AntDIcons from '@ant-design/icons';
import { FileImageOutlined, FilePdfOutlined, FilePptOutlined, FileWordOutlined, FileExcelOutlined, VideoCameraOutlined, FileOutlined } from '@ant-design/icons';
import {
   EnglishKReport, English1Report, English2Report, English3Report, English4Report, English5Report, English6Report, English7Report, English8Report, English9Report, English10Report,
   ScienceKReport, Science1Report, Science2Report, Science3Report, Science4Report, Science5Report, Science6Report, Science7Report, Science8Report, Science9Report, Science10Report,
   MathKReport, Math1Report, Math2Report, Math3Report, Math4Report, Math5Report, Math6Report, Math7Report, Math8Report, Math9Report, Math10Report,
   Grade1SummaryReport, Grade2SummaryReport, Grade3SummaryReport, Grade4SummaryReport, Grade5SummaryReport, Grade6SummaryReport, Grade7SummaryReport, Grade8SummaryReport,
   Grade9SummaryReport, Grade10SummaryReport, KinderSummaryReport,
   GMG11Report, Physics1G12Report, Biology1G12Report, FABM2G12Report, WRBSG12Report, OCG11Report, PPGG12Report, BFG12Report, BESRG12Report, RAWG11Report, CWG12Report, TNCTG12Report,
   GP2G12Report, GB2G12Report, SPG11Report, AEG12Report,

   MTLanguageKReport, MTScienceKReport, MTMathKReport, MTKLanguageSummaryReport, MTKScienceSummaryReport, MTKMathSummaryReport,
   MTG1LanguageReport, MTG1MathReport, MTG1RALReport, MTG1LanguageSummaryReport, MTG1MathSummaryReport, MTG1RALSummaryReport,
   MTG4EnglishReport, MTG4MathReport, MTG4ScienceReport, MTG4EnglishSummaryReport, MTG4MathSummaryReport, MTG4ScienceSummaryReport,
   MTG7EnglishReport, MTG7MathReport, MTG7ScienceReport, MTG7EnglishSummaryReport, MTG7MathSummaryReport, MTG7ScienceSummaryReport,

   BFG12SummaryReport, PPGG12SummaryReport, GP1G12SummaryReport, GB1G12SummaryReport, FABM2G12SummaryReport, WRBSG12SummaryReport, OCG11SummaryReport, GMG11SummaryReport, RAWG11SummaryReport,
   CWG12SummaryReport, TNCTG12SummaryReport, BESRG12SummaryReport, GP2G12SummaryReport, GB2G12SummaryReport, SPG11SummaryReport, AEG12SummaryReport,
   BC12Report, CHEM212Report, DIASS12Report, OM12Report, BC12SummaryReport, CHEM212SummaryReport, DIASS12SummaryReport, OM12SummaryReport
} from '../pages/DiagnosticAssessmentPage/reports';
// import { getTwoToneColor, setTwoToneColor } from '@ant-design/icons';
import recursivelyLowercaseJSONKeys from 'recursive-lowercase-json';
import { Buffer } from 'buffer';
import moment from 'moment';

const subdomain = localStorage.getItem("lms-subdomain");

const decodeJwt = () => {
   const jwt = localStorage.getItem('lms-jwt');

   if (jwt) {
      var decodedString = jwtDecode(jwt);
      return decodedString;
   }
   else {
      window.location.href = '/';
      return;
   }
}

const getCurrentUserInfo = (type) => {
   const jwt = localStorage.getItem('lms-jwt');

   if (jwt) {
      var decodedString = jwtDecode(jwt);
      if (type === Enums.UserInfo.role)
         return decodedString.role;
      if (type === Enums.UserInfo.username)
         return decodedString.username;
      if (type === Enums.UserInfo.id)
         return decodedString[Enums.UserInfo.id];
      if (type === Enums.UserInfo.fullname)
         return decodedString.unique_name;
      if (type === Enums.UserInfo.otherdata)
         return decodedString[Enums.UserInfo.otherdata];
   }
   else {
      window.location.href = '/';
      return;
   }
}

const checkFileImage = (type) => {
   switch (type) {
      case Enums.FileType.xls: case Enums.FileType.xlsx:
         return Enums.FileTypeImage.excel;
      case Enums.FileType.docx: case Enums.FileType.doc:
         return Enums.FileTypeImage.word;
      case Enums.FileType.pptx:
         return Enums.FileTypeImage.ppt;
      case Enums.FileType.ppsx:
         return Enums.FileTypeImage.ppsx;
      case Enums.FileType.pdf:
         return Enums.FileTypeImage.pdf;
      case Enums.FileType.jpeg: case Enums.FileType.png: case Enums.FileType.bmp:
         return Enums.FileTypeImage.img;
      case Enums.FileType.mp4:
         return Enums.FileTypeImage.mp4;
      default:
         return Enums.FileTypeImage.others;
   }
}

const verifyJwt = async () => {
   const jwt = localStorage.getItem('lms-jwt');

   if (jwt) {
      try {
         await LoginService.jwtValidation().catch((e) => {
            window.location.href = '/';
            return;
         })
      }
      catch {
         window.location.href = '/';
         return;
      }
   }
   else {
      window.location.href = '/';
      return;
   }
};

const convertKeysToLowerCase = (obj) => {
   // const isObject = o => Object.prototype.toString.apply(o) === '[object Object]'
   // const isArray = o => Object.prototype.toString.apply(o) === '[object Array]'

   // let transformedObj = isArray(obj) ? [] : {}

   // for (let key in obj) {
   //    // replace the following with any transform function
   //    const transformedKey = key.toLowerCase()

   //    if (isObject(obj[key]) || isArray(obj[key])) {
   //       transformedObj[transformedKey] = convertKeysToLowerCase(obj[key])
   //    } else {
   //       transformedObj[transformedKey] = obj[key]
   //    }
   // }
   var transformedObj = recursivelyLowercaseJSONKeys(obj)
   return transformedObj
};

function getFileIcon(fileName) {
   // setTwoToneColor("#70d0d4");
   // getTwoToneColor();
   var retVal = null;

   const fileExtension = fileName.split(".").pop();

   switch (fileExtension.toUpperCase()) {
      case "PNG":
      case "JPG":
      case "JPEG":
         retVal = <FileImageOutlined />;
         break;
      case "PDF":
         retVal = <FilePdfOutlined />;
         break;
      case "PPT":
      case "PPTX":
         retVal = <FilePptOutlined />;
         break;
      case "DOC":
      case "DOCX":
         retVal = <FileWordOutlined />;
         break;
      case "XLS":
      case "XLSX":
         retVal = <FileExcelOutlined />;
         break;
      case "MP4":
      case "AVI":
         retVal = <VideoCameraOutlined />;
         break;
      default:
         retVal = <FileOutlined />;
         break;
   }

   return retVal;
}

function getPercentage(data, proficiency) {
   if (data) {
      if (proficiency === 'beginner')
         return (data.beginner / (data.beginner + data.basic + data.competent) * 100).toFixed(2);

      if (proficiency === 'basic')
         return (data.basic / (data.beginner + data.basic + data.competent) * 100).toFixed(2);

      if (proficiency === 'competent')
         return (data.competent / (data.beginner + data.basic + data.competent) * 100).toFixed(2);
   }
}

const displayDiagnosticReport = (template, assign_id, subjectID, subject, studentID, assessment_id, school_year) => {
   if (subjectID !== null) {
      const reportComponents = {
         'PreKinder': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Kindergarten': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Kindergarten 1': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Kindergarten 2': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Casa': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Advance Casa': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Senior Casa': {
            english: EnglishKReport,
            math: MathKReport,
            science: ScienceKReport,
            mtlang: MTLanguageKReport,
            mtmath: MTMathKReport,
            mtsci: MTScienceKReport,
         },
         'Grade 1': {
            english: English1Report,
            math: Math1Report,
            science: Science1Report,
            mtlang: MTG1LanguageReport,
            mtmath: MTG1MathReport,
            mtral: MTG1RALReport,
         },
         'Grade 2': {
            english: English2Report,
            math: Math2Report,
            science: Science2Report,
         },
         'Grade 3': {
            english: English3Report,
            math: Math3Report,
            science: Science3Report,
         },
         'Grade 4': {
            english: English4Report,
            math: Math4Report,
            science: Science4Report,
            mteng: MTG4EnglishReport,
            mtmath: MTG4MathReport,
            mtsci: MTG4ScienceReport,
         },
         'Grade 5': {
            english: English5Report,
            math: Math5Report,
            science: Science5Report,
         },
         'Grade 6': {
            english: English6Report,
            math: Math6Report,
            science: Science6Report,
         },
         'Grade 7': {
            english: English7Report,
            math: Math7Report,
            science: Science7Report,
            mteng: MTG7EnglishReport,
            mtmath: MTG7MathReport,
            mtsci: MTG7ScienceReport,
         },
         'Grade 8': {
            english: English8Report,
            math: Math8Report,
            science: Science8Report,
         },
         'Grade 9': {
            english: English9Report,
            math: Math9Report,
            science: Science9Report,
         },
         'Grade 10': {
            english: English10Report,
            math: Math10Report,
            science: Science10Report,
         },
         'Grade 11': {
            oc: OCG11Report,
            raw: RAWG11Report,
            gm: GMG11Report,
            stats: SPG11Report,
         },
         'Grade 12': {
            besr: BESRG12Report,
            gp1: Physics1G12Report,
            gb1: Biology1G12Report,
            gp2: GP2G12Report,
            gb2: GB2G12Report,
            fabm2: FABM2G12Report,
            wrbs: WRBSG12Report,
            ppg: PPGG12Report,
            bf: BFG12Report,
            cw: CWG12Report,
            tnct: TNCTG12Report,
            ae: AEG12Report,
            bc: BC12Report,
            chem2: CHEM212Report,
            diass: DIASS12Report,
            om: OM12Report,
         },
      };

      //    const kinderReports = {
      //       english: EnglishKReport,
      //       math: MathKReport,
      //       science: ScienceKReport,
      //       mtlang: MTLanguageKReport,
      //       mtmath: MTMathKReport,
      //       mtsci: MTScienceKReport,
      //    };

      //    const reportComponents = {
      //       // Consolidate all kindergarten levels
      //       ...['PreKinder', 'Kindergarten', 'Kindergarten 1', 'Kindergarten 2', 'Casa', 'Advance Casa', 'Senior Casa']
      //          .reduce((acc, level) => ({ ...acc, [level]: kinderReports }), {}),

      //       // Grade 1-10 with standard subjects
      //       ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].reduce((acc, grade) => ({
      //          ...acc,
      //          [`Grade ${grade}`]: {
      //             english: `English${grade}Report`,
      //             math: `Math${grade}Report`,
      //             science: `Science${grade}Report`,
      //             // Additional subjects for specific grades
      //             ...(grade === 1 && {
      //                mtlang: MTG1LanguageReport,
      //                mtmath: MTG1MathReport,
      //                mtral: MTG1RALReport,
      //             }),
      //             ...(grade === 4 && {
      //                mteng: MTG4EnglishReport,
      //                mtmath: MTG4MathReport,
      //                mtsci: MTG4ScienceReport,
      //             }),
      //             ...(grade === 7 && {
      //                mteng: MTG7EnglishReport,
      //                mtmath: MTG7MathReport,
      //                mtsci: MTG7ScienceReport,
      //             }),
      //          },
      //       }), {}),

      //       // Grade 11
      //       'Grade 11': {
      //          oc: OCG11Report,
      //          raw: RAWG11Report,
      //          gm: GMG11Report,
      //          stats: SPG11Report,
      //       },

      //       // Grade 12
      //       'Grade 12': {
      //          besr: BESRG12Report,
      //          gp1: Physics1G12Report,
      //          gb1: Biology1G12Report,
      //          gp2: GP2G12Report,
      //          gb2: GB2G12Report,
      //          fabm2: FABM2G12Report,
      //          wrbs: WRBSG12Report,
      //          ppg: PPGG12Report,
      //          bf: BFG12Report,
      //          cw: CWG12Report,
      //          tnct: TNCTG12Report,
      //          ae: AEG12Report,
      //          bc: BC12Report,
      //          chem2: CHEM212Report,
      //          diass: DIASS12Report,
      //          om: OM12Report,
      //       },
      //    };

      const ReportComponent = reportComponents[template]?.[subjectID];
      if (ReportComponent) {
         return (
            <ReportComponent
               subject={subject}
               assignment_id={assign_id}
               student_id={studentID}
               template={template}
               subject_id={subjectID}
               assessment_id={assessment_id}
               school_year={school_year}
            />
         );
      }
   }
}

function GetProficiency(percentage) {
   if (percentage >= 0 && percentage <= 59.49)
      return "BEGINNER";

   if (percentage >= 59.50 && percentage <= 79.49)
      return "PROFICIENT";

   if (percentage >= 79.50 && percentage <= 100)
      return "COMPETENT";
}

function GetCardBackground(subject, level) {
   var retVal = 'bg_default.png';

   if (level === 'formative_1')
      retVal = 'bg_l1_' + subject.toLowerCase().replace(/ /g, "_") + ".png";

   if (level === 'formative_2')
      retVal = 'bg_l2_' + subject.toLowerCase().replace(/ /g, "_") + ".png";

   if (level === 'formative_3')
      retVal = 'bg_l3_' + subject.toLowerCase().replace(/ /g, "_") + ".png";

   // switch (level) {
   //    case 'kinder':
   //    case 'grade 1':
   //    case 'grade 2':
   //    case 'grade 3':
   //    case 'grade 4':
   //    case 'grade 5':
   //    case 'grade 6':
   //       retVal = 'bg_gs_' + subject.toLowerCase().replace(/ /g, "_") + ".png";
   //       break;
   //    case 'grade 7':
   //    case 'grade 8':
   //    case 'grade 9':
   //    case 'grade 10':
   //    case 'grade 11':
   //    case 'grade 12':
   //       retVal = 'bg_jhs_' + subject.toLowerCase().replace(/ /g, "_") + ".png";
   //       break;
   // }

   return retVal;
}

const getBase64 = (img, callback) => {
   const reader = new FileReader();
   reader.addEventListener('load', () => callback(reader.result));
   reader.readAsDataURL(img);
}

function convertLetterToNumber(letter) {
   if (letter !== null && letter !== undefined && letter !== '') {
      const charCode = letter.charCodeAt(0);
      if (charCode >= 65 && charCode <= 90) {
         return charCode - 64;
      } else {
         return '';
      }
   } else return '';
}

function generateSequenceNumbers(max_no) {
   const numbers = Array(max_no).fill().map((_, index) => index + 1);
   numbers.sort(() => Math.random() - 0.5);

   return numbers;
}

function shuffle(array) {
   for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
   }
   return array;
}

function generateSequenceNumbersV2(data) {
   const numbers = [];
   let tmpArray = [];

   for (let i = 0; i < data.length; i++) {
      if (data[i].type.includes("section") || i === data.length - 1)
         if (tmpArray.length > 0) {
            let s = shuffle(tmpArray);
            numbers.push(...s);
            numbers.push(i + 1);
            tmpArray = [];
         }
         else
            numbers.push(i + 1);
      else {
         tmpArray.push(i + 1);
      }
   }

   return numbers;
}

function removeSpaces(str) {
   return str.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
}

function GetTypeLabel(assessment_type) {
   switch (assessment_type) {
      case 'formative_1':
         return 'Formative Level 1';
      case 'formative_2':
         return 'Formative Level 2';
      case 'formative_3':
         return 'Formative Level 3';
      case 'summative':
         return 'Summative';
      case 'study_plan_1':
         return 'Study Plan 1';
      case 'study_plan_2':
         return 'Study Plan 2';
   }
}

function dataUrlToFile(dataUrl, filename) {
   const arr = dataUrl.split(',');
   if (arr.length < 2) { return undefined; }
   const mimeArr = arr[0].match(/:(.*?);/);
   if (!mimeArr || mimeArr.length < 2) { return undefined; }
   const mime = mimeArr[1];
   const buff = Buffer.from(arr[1], 'base64');
   return new File([buff], filename, { type: mime });
}

function GetFormLocation(value) {
   switch (value) {
      case 0:
         return 'All';
      case 1:
         return 'Form 1';
      case 2:
         return 'Form 2';
      case 3:
         return 'Form 3';
      case 4:
         return 'Form 4';
   }
}

function standardDeviation(arr) {
   let mean = arr.reduce((acc, curr) => {
      return acc + curr
   }, 0) / arr.length;

   arr = arr.map((el) => {
      return (el - mean) ** 2
   })

   let total = arr.reduce((acc, curr) => acc + curr, 0);

   return Math.sqrt(total / arr.length);
}

const calculateStats = (data, scoreFields, mean, stdDev, ranges, isPost) => {
   let total = 0;
   let min = 0;
   let max = 0;
   const scores = [];
   let beginner = 0;
   let basic = 0;
   let competent = 0;

   data.forEach(item => {
      const sum = scoreFields.reduce((acc, field) => acc + item[field], 0);
      min = Math.min(min, sum);
      max = Math.max(max, sum);
      total += sum;
      scores.push(sum);

      const zScore = (sum - mean) / stdDev;
      if (zScore > 1) competent++;
      else if (zScore > -0.51) basic++;
      else if (zScore > -10) beginner++;
   });

   const average = parseFloat((total / data.length).toFixed(2));
   const proficiency = ranges.reduce((prev, [rangeMin, rangeMax, level]) =>
      average >= rangeMin && average <= rangeMax ? level : prev, '');

   return {
      vn: data.length,
      prem: isPost ? -1 : average,
      postm: isPost ? average : -1,
      min,
      max,
      sd: standardDeviation(scores),
      proficiency,
      beginner,
      basic,
      competent
   };
};

// Single function to handle data extraction Diagnostic Summary Report for all subjects
const extractDataForDiagnosticSummaryReport = (diagnostic_type, pre_data, post_data, subjectConfigs) => {
   const { categories, totalRanges, setters } = subjectConfigs;
   const isPost = diagnostic_type === 'post';

   // Determine which data to use based on diagnostic type and availability
   const primaryData = isPost && post_data.length ? post_data : pre_data;

   // Calculate stats for each category
   const results = Object.entries(categories).reduce((acc, [key, { fields, mean, stdDev, ranges }]) => {
      // Compute stats for primary data (pre or post based on diagnostic_type)
      acc[key] = calculateStats(primaryData, fields, mean, stdDev, ranges, isPost);

      // If post data exists and we're not in post-only mode, calculate post mean
      if (post_data.length && !isPost) {
         var postm_ave = parseFloat((post_data.reduce((sum, item) => sum + fields.reduce((s, f) => s + item[f], 0), 0) / post_data.length).toFixed(2));
         acc[key].postm = isNaN(postm_ave) ? 0 : postm_ave;
      }
      else {
         var pre_ave = parseFloat((pre_data.reduce((sum, item) => sum + fields.reduce((s, f) => s + item[f], 0), 0) / pre_data.length).toFixed(2));
         acc[key].prem = isNaN(pre_ave) ? 0 : pre_ave;
      }


      return acc;
   }, {});

   // Aggregate totals across all categories
   const total = Object.values(results).reduce((acc, cat) => ({
      vn: isPost ? post_data.length : pre_data.length,
      prem: acc.prem + cat.prem,
      postm: acc.postm + cat.postm,
      min: acc.min + cat.min,
      max: acc.max + cat.max,
      sd: acc.sd + cat.sd,
      beginner: acc.beginner + cat.beginner,
      basic: acc.basic + cat.basic,
      competent: acc.competent + cat.competent
   }), { prem: 0, postm: 0, min: 0, max: 0, sd: 0, beginner: 0, basic: 0, competent: 0 });

   // Determine overall proficiency based on total score
   const totalScore = post_data.length ? total.postm : total.prem;
   total.proficiency = totalRanges.find(([min, max]) => totalScore >= min && totalScore <= max)?.[2] || '';

   // Update component state with calculated results
   Object.entries(setters).forEach(([key, setter]) => setter(key === 'total' ? total : results[key]));
};

const downloadFile = async (url, filename) => {
   // var name = moment().format("MM-DD-YYYY");

   // var re = new RegExp(' ', 'g');
   var finalUrl = `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${url}`;
   var file_name = filename; //name.replace(re, '_');
   var pos = finalUrl.lastIndexOf('.');
   var ext = finalUrl.slice(pos);

   fetch(finalUrl)
      .then(response => {
         response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = file_name + ext;
            a.click();
         });
      });
};

function hasBraineeResourcesAccess(sdbomain) {
   return ['campuscloudacademy', 'dbti-makati', 'dev', 'localhost', 'ccph', 'bcs', 'gsa', 'hia', 'lamblights', 'mdochs', 'na', 'olmhra', 'pcs', 'pga', 'sha', 'snsr'].includes(sdbomain);
}

function determineOnlineOffline() {
   // return window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/gi) ? "offline" : "online";
   return window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|\.campus|^$/gi) ? "offline" : "online";
}

function colorize() {
   var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
      g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
      b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   return '#' + r + g + b;
}

const modules = {
   checkFileImage,
   verifyJwt,
   convertKeysToLowerCase,
   decodeJwt,
   getCurrentUserInfo,
   GetFileIcon: getFileIcon,
   getPercentage,
   displayDiagnosticReport,
   GetProficiency,
   GetCardBackground,
   getBase64,
   convertLetterToNumber,
   generateSequenceNumbers,
   removeSpaces,
   GetTypeLabel,
   dataUrlToFile,
   generateSequenceNumbersV2,
   GetFormLocation,
   standardDeviation,
   calculateStats,
   extractDataForDiagnosticSummaryReport,
   downloadFile,
   hasBraineeResourcesAccess,
   determineOnlineOffline,
   colorize
};

export default modules;